// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ng-1";
export var messageSideRight = "_ng-2";
export var subscribeToBackInStockBubbleContainer = "_ng-0";